/* eslint-disable react/jsx-pascal-case */
import { Step, StepLabel, Stepper } from '@material-ui/core';
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import css from './styles.module.scss';
import { useLocation } from 'react-router-dom';
import { Step_1 } from '~/features/dashboard/components/add-money/components/step-1';
import { Step_2 } from '~/features/dashboard/components/add-money/components/step-2';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import { selectNewDealStep } from '~/features/dashboard/store/selectors';
import { newDealFormPrevStep, resetNewDealForm } from '~/features/dashboard/store/actions';
import { NEW_MONIES_FORM_STEPS_COUNT } from '~/features/dashboard';
import { LabelStepMoney } from '~/models/music/new-song/helpers';
import { makeStyles } from '@material-ui/core/styles';
import { StepIconProps } from '@material-ui/core/StepIcon';
import clsx from 'clsx';
import Check from '@material-ui/icons/Check';
import { Step_4 } from '~/features/dashboard/components/add-money/components/step-4';
import { Step_3 } from '~/features/dashboard/components/add-money/components/step-3';
import { Step_5 } from '~/features/dashboard/components/add-money/components/step-5';
import { Step_6 } from '~/features/dashboard/components/add-money/components/step-6';

interface MyMoneyAddProps {}

export const AddMoney: React.FC<MyMoneyAddProps> = () => {
    const step = useSelector(selectNewDealStep);

    const dispatch = useDispatch();

    const location = useLocation();

    useEffect(() => {
        if (location.state === undefined) {
            dispatch(resetNewDealForm());
        }
    }, [dispatch, location]);

    const prevStep = useCallback(() => {
        dispatch(newDealFormPrevStep());
    }, [dispatch]);

    const useQontoStepIconStyles = makeStyles({
        root: {
            color: '#eaeaf0',
            display: 'flex',
            height: 22,
            alignItems: 'center',
        },
        active: {
            color: '#8eb46d',
        },
        circle: {
            width: 40,
            height: 40,
            borderRadius: '50%',
            backgroundColor: 'currentColor',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        completed: {
            color: '#fff',
            backgroundColor: '#8eb46d',
            zIndex: 1,
            fontSize: 18,
            width: 40,
            height: 40,
            padding: 8,
            borderRadius: '100%',
        },
    });

    function QontoStepIcon(props: StepIconProps) {
        const classes = useQontoStepIconStyles();
        const { active, completed, icon } = props;

        return (
            <div
                className={clsx(classes.root, {
                    [classes.active]: active,
                })}
            >
                {completed ? (
                    <Check className={classes.completed} />
                ) : (
                    <div className={classes.circle}>
                        <span className={css.spanCircle}>{icon}</span>
                    </div>
                )}
            </div>
        );
    }

    return (
        <div className={css.module}>
            <MuiPickersUtilsProvider utils={MomentUtils}>
                <>
                    <Stepper alternativeLabel activeStep={step - 1}>
                        {Array.from({ length: NEW_MONIES_FORM_STEPS_COUNT }, () => '').map((_, index) => (
                            <Step key={index}>
                                <StepLabel className={css.stepspan} StepIconComponent={QontoStepIcon}>
                                    {LabelStepMoney[index]}
                                </StepLabel>
                            </Step>
                        ))}
                    </Stepper>
                    {step === 1 && <Step_1 />}
                    {step === 2 && <Step_2 prevStep={prevStep} />}
                    {step === 3 && <Step_3 prevStep={prevStep} />}
                    {step === 4 && <Step_4 prevStep={prevStep} />}
                    {step === 5 && <Step_5 prevStep={prevStep} />}
                    {step === 6 && <Step_6 prevStep={prevStep} />}
                </>
            </MuiPickersUtilsProvider>
        </div>
    );
};
